import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import DownIcon from "@iconify/icons-mdi/menu-down";
import { IconifyIcon, InlineIcon } from "@iconify/react";
import { useMyTimesheetFilterOpenState } from "my-timesheet/hooks";

interface MyTimesheetFilterItemProps {
  icon: string | IconifyIcon; // Replace 'string' with the appropriate type if needed
  label: string;
  selectedItemsCount: number;
  type: string;
  isMobile: boolean;
}

export const MyTimesheetFilterItem: React.FC<MyTimesheetFilterItemProps> = ({
  icon,
  label,
  selectedItemsCount,
  type,
  isMobile,
}) => {
  const theme = useTheme();

  const { state: openedFilter, setState: setOpenedFilter } =
    useMyTimesheetFilterOpenState();

  const handleOpenedFilter = () => {
    const getState = (itemType: string) => {
      if (type === itemType && !openedFilter[itemType]) {
        return true;
      }
      return false;
    };
    const newState = {
      contract: getState("contract"),
      client: getState("client"),
      project: getState("project"),
      cost: getState("cost"),
    };
    setOpenedFilter({ ...openedFilter, ...newState });
  };

  return (
    <Box
      id={`filter-item-${type}`}
      display="flex"
      flexDirection="row"
      justifyContent="flex-start"
      alignItems="center"
      padding="10px 10px 10px 16px"
      style={{
        position: "relative",
        backgroundColor: isMobile && openedFilter[type] ? "white" : "unset",
      }}
    >
      <InlineIcon
        icon={icon}
        width="24px"
        style={{
          color: theme.palette.darkBase.main,
        }}
      />
      {selectedItemsCount > 0 && (
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          style={{
            fontSize: "10px",
            fontWeight: 500,
            lineHeight: "10px",
            color: theme.palette.white.main,
            position: "absolute",
            left: "32px",
            top: "4px",
            borderRadius: "2px",
            height: "16px",
            width: "16px",
            backgroundColor: theme.palette.primary.main,
          }}
        >
          {selectedItemsCount}
        </Box>
      )}
      <Box width="10px" />
      <Typography
        style={{
          color: theme.palette.darkBase.main,
        }}
      >
        {label}
      </Typography>
      <Box width="10px" />
      <IconButton
        id="filter-collapse-button"
        onClick={() => {
          handleOpenedFilter();
        }}
        aria-expanded={openedFilter[type]}
        aria-label="show more"
        style={
          openedFilter[type]
            ? {
                padding: 0,
                transform: "rotate(180deg)",
              }
            : {
                padding: 0,
              }
        }
      >
        <InlineIcon
          icon={DownIcon}
          width="24px"
          style={{
            color: theme.palette.darkBase.main,
          }}
        />
      </IconButton>
    </Box>
  );
};

export default MyTimesheetFilterItem;
